import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-simulator',
  templateUrl: './fh-svg-simulator.component.html',
  styleUrl: './fh-svg-simulator.component.scss'
})
export class FhSvgSimulatorComponent {
  @Input() color: string = '';
}
